import { render, staticRenderFns } from "./AwardFillin.vue?vue&type=template&id=6a124a44&scoped=true"
import script from "./AwardFillin.vue?vue&type=script&lang=js"
export * from "./AwardFillin.vue?vue&type=script&lang=js"
import style0 from "./AwardFillin.vue?vue&type=style&index=0&id=6a124a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a124a44",
  null
  
)

export default component.exports